











import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class CvvModal extends Vue {
    @Prop({ required: true, type: Boolean })
    value!: boolean;

    @Watch("value")
    valueChange(): void {
        this.$emit("input", this.value);
    }
}
